.right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
}

.view-switch {
  span:not([data-active='true']) svg {
    color: var(--color-texts-low-contrast);
  }
}
